import { render } from "./AddEditEmployer.vue?vue&type=template&id=3f48aacc"
import script from "./AddEditEmployer.vue?vue&type=script&lang=js"
export * from "./AddEditEmployer.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src3444732531/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__